import {
  CLEAN_ITEMS_FILTERS,
  CLEAN_ORGANISM_BY_RUT_FILTERS,
  CLEAN_ORGANISM_FILTERS,
  CLEAN_PROVIDER_FILTERS,
  GET_ITEMS_ERROR,
  GET_ITEMS_SUCCESS,
  GET_ITEMS,
  GET_ORGANIZATIONS_BY_RUT_ERROR,
  GET_ORGANIZATIONS_BY_RUT_SUCCESS,
  GET_ORGANIZATIONS_BY_RUT,
  GET_ORGANIZATIONS_ERROR,
  GET_ORGANIZATIONS_SUCCESS,
  GET_ORGANIZATIONS,
  GET_PROVIDERS_ERROR,
  GET_PROVIDERS_SUCCESS,
  GET_PROVIDERS,
  GET_REGIONS_ERROR,
  GET_REGIONS_SUCCESS,
  GET_REGIONS
} from './DirectDealFilter.actions'

const directDealFiltersState = {
  error: undefined,
  loading: false,
  providers: [],
  organizations: [],
  organizationsByRut: [],
  items: [],
  regions: []
}

/**
 * The DirectDealFilters reducer.
 */
const directDealFiltersReducer = (state = directDealFiltersState, { payload, type }) => {
  switch (type) {
    case GET_REGIONS:
    case GET_ITEMS:
    case GET_ORGANIZATIONS:
    case GET_ORGANIZATIONS_BY_RUT:
    case GET_PROVIDERS: {
      return { ...state, error: undefined, loading: true }
    }
    case GET_REGIONS_ERROR:
    case GET_ITEMS_ERROR:
    case GET_ORGANIZATIONS_ERROR:
    case GET_ORGANIZATIONS_BY_RUT_ERROR:
    case GET_PROVIDERS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_PROVIDERS_SUCCESS: {
      return { ...state, error: undefined, loading: false, providers: payload.providers }
    }
    case GET_ORGANIZATIONS_SUCCESS: {
      return { ...state, error: undefined, loading: false, organizations: payload.organizations }
    }
    case GET_ORGANIZATIONS_BY_RUT_SUCCESS: {
      return { ...state, error: undefined, loading: false, organizationsByRut: payload.organizationsByRut }
    }
    case GET_ITEMS_SUCCESS: {
      return { ...state, error: undefined, loading: false, items: payload.items }
    }
    case GET_REGIONS_SUCCESS: {
      return { ...state, error: undefined, loading: false, regions: payload.regions }
    }
    case CLEAN_ITEMS_FILTERS: {
      return { ...state, items: state.items.filter(item => item.value === Number.parseInt(payload?.item, 10)) }
    }
    case CLEAN_ORGANISM_FILTERS: {
      return {
        ...state,
        organizations: state.organizations.filter(organization => organization.value === payload?.organization)
      }
    }
    case CLEAN_PROVIDER_FILTERS: {
      return { ...state, providers: state.providers.filter(provider => provider.value === payload?.provider) }
    }
    case CLEAN_ORGANISM_BY_RUT_FILTERS: {
      return {
        ...state,
        organizationsByRut: state.organizationsByRut.filter(
          organization => organization.value === payload?.organization
        )
      }
    }
    default: {
      return state
    }
  }
}

export default directDealFiltersReducer
